import Axios from '../axios-instance';

const LogisticsAPI = {
  getLogisticGrid: body => {
    return Axios.post('/Logistics/getLogisticGrid', body).then(({ data }) => data);
  },
  approveReferences: body => {
    return Axios.put('/Logistics/changeAcerBragState', body).then(({ data }) => data);
  },
  confirmInvoices: body => {
    return Axios.put('/Logistics/changeSupplierState', body).then(({ data }) => data);
  },
  exportToExcel: body => {
    return Axios.post('/Logistics/exportToExcel', body, { responseType: 'arraybuffer' }).then(({ data }) => data);
  },
  getComment: body => {
    return Axios.post('/Logistics/getComment', body).then(({ data }) => data);
  },
  setComment: body => {
    return Axios.post('/Logistics/setComment', body).then(({ data }) => data);
  },
};

export default LogisticsAPI;
